import { AutomationWorkflows } from '../constants/features';
import { FeatureAccessValue, usePlanFeatureGate } from './use-plan-feature-gate';

export const useHasAutomationWorkflowsFeatureGate = (): boolean => {
  const { isFeatureEnabled } = usePlanFeatureGate(AutomationWorkflows, FeatureAccessValue.Disabled);
  return isFeatureEnabled;
};
